import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

import imagesLoaded from 'imagesloaded';

import BreadCrumbs 				from '../common/_BreadCrumbs.jsx';
import CollectionCard 			from '../common/_CollectionCard.jsx';
import HiddenScroll 			from '../common/_HiddenScroll.jsx';
import CustomCheckbox 			from '../common/_CustomCheckbox.jsx';
import CustomRadio 				from '../common/_CustomRadio.jsx';
import ModalFrame 				from '../common/_ModalFrame.jsx';

import ProductCard 				from '../common/_ProductCard.jsx';
import ProductListingItem 		from '../common/_ProductListingItem.jsx';
import CatalogCategoryCard 		from '../common/_CatalogCategoryCard.jsx';
import PartColorCard 			from '../common/_PartColorCard.jsx';
import PartColorListingItem 	from '../common/_PartColorListingItem.jsx';
import Pagination 				from '../common/_Pagination.jsx';

import SearchModalContent 		from '../modals/_SearchModalContent.jsx';

import {ToggleScroll} 			from '../common/_Utilities.jsx';
import {BrickheadGlasses, BrickheadMeh} 		from '../common/_Brickheads.jsx';


export default class CatalogBrowse extends BLComponent 
{
	constructor(props, context) 
	{
		super( props, context );

		this.browseInfo	= blapp.models.get( "browseInfo" );

		this.buildFromBrowseInfo();

		this.state = 
			{
				dummy:					0
			,	fetchSerial:			100
			,	cateItems:	 			{}
			,	selectedCatStr:			( this.browseInfo && this.browseInfo.dmBaseCategory ) ? this.browseInfo.dmBaseCategory.strCatStr : ""
			,	colorGroupSelected:		0
			,	selectedColors:			{}
			,	selectedStudX:			""
			,	selectedStudY:			""
			,	selectedDecoration: 	"Any"
			,	activeElementsOnly: 	false
			,	selectedYear:			0
			,	selectedPartCount: 		0
			,	selectedPackaging: 		"Any"
			,	filterKeyword: 			''
			,	sortType:				0
			,	sortDirection:			-1
			,	partFilter: 			true
			,	listType: 				'card'

			,	showSearchModal: 	false
			,	activeTheme: 			0
			,	themeView: 				0
			,	activeCategory: 		'Buildable Figures'
			,	subCategoryOpen:		( blapp.util.getUrlVar( "so" ) || "" )
			,	showAll:				false
			,	openCard: 				-1
			,	currentPage:			1
			,	postsPerPage:			96
		};

		this.keepLastState( true, "BrowseResult", "listType" );

		this.state	= _.assign( this.state, this.getNewStateFromBrowseInfo() );
		
		this.highlightedCollections = 
			[
					{"idCollection":1000,"strTitle":"I Choo Choo Choose You","idUserAuthor":406410,"strAuthorOverride":"BrickLink","strSubTitle":"The Ultimate Train Collection ","idFileInfoCoverImg":838250,"urlCustomCoverImg":"","strCaptionCoverImg":"Caption","strSourceCoverImg":"","strTeaser":"","statusCollection":1,"nFollowingCnt":0,"isFollowing":false,"nLikesCnt":0,"isLiked":false,"showAsUpdated":false,"tsCreated":1542755491970,"tsPublished":1542744000970,"tsModified":null,"urlFileCover":"//file.bricklink.com/25/838/838250.png","dmUserAuthor":{"idUser":406410,"skUsername":"k88club","typeUser":1,"strTypeUserName":"Buyer","statusBuyer":0,"statusSeller":3,"idProfileImg":92,"nProfileRevision":1,"nFeedbackScore":4,"codeCountry":"US","idState":5599,"hasAboutMe":false,"hasMergeLog":false,"strUsernamePrev":null,"userRegistered":true,"store":null,"dtMemberSince":1371625200039},"arrTags":["Train"],"arrPreviewItems":null,"arrBlocks":null}
				,	{"idCollection":1000,"strTitle":"I Choo Choo Choose You","idUserAuthor":406410,"strAuthorOverride":"BrickLink","strSubTitle":"The Ultimate Train Collection ","idFileInfoCoverImg":838250,"urlCustomCoverImg":"","strCaptionCoverImg":"Caption","strSourceCoverImg":"","strTeaser":"","statusCollection":1,"nFollowingCnt":0,"isFollowing":false,"nLikesCnt":0,"isLiked":false,"showAsUpdated":false,"tsCreated":1542755491970,"tsPublished":1542744000970,"tsModified":null,"urlFileCover":"//file.bricklink.com/25/838/838250.png","dmUserAuthor":{"idUser":406410,"skUsername":"k88club","typeUser":1,"strTypeUserName":"Buyer","statusBuyer":0,"statusSeller":3,"idProfileImg":92,"nProfileRevision":1,"nFeedbackScore":4,"codeCountry":"US","idState":5599,"hasAboutMe":false,"hasMergeLog":false,"strUsernamePrev":null,"userRegistered":true,"store":null,"dtMemberSince":1371625200039},"arrTags":["Train"],"arrPreviewItems":null,"arrBlocks":null}
			];
	}

	componentDidMount() 
	{
		this.initStickySidebar();
		this.registerPopStateCallback( ( e ) => this.onPopState( e ) );

		this.initWindowSizeMenu();

		window.addEventListener(
			'resize'
		,	() => 
			{
				if ( window.innerWidth < 840 ) 
				{
					if ( !this.state.isMobile ) 
					{
						this.setState({isMobile: true});
						this.sidebar.style.height = '';
						this.sidebar.style.transform = '';
					}
				}
				else
				{
					if ( this.state.isMobile ) 
					{
						this.setState({isMobile: false});
					}
				}
			}
		);

		if ( window.innerWidth < 840 ) 
		{
			this.setState({isMobile: true});
		}

		const active = document.querySelectorAll('.sidenav-tree__group-item-children-item--active')[0] || document.querySelectorAll('.sidenav-tree__group-item-title--active')[0];
		
		if(active) {
			active.scrollIntoView(true);
		}
	}

	componentDidUpdate( prevProps, prevState, snapshot ) 
	{
		this.initStickySidebar();
		
		if (typeof this.prevShowCategory == "undefined") this.prevShowCategory = false;

		if (this.prevShowCategory != ( this.state.showAll || this.catalogLevel > 0 ))
		{
			window.scrollTo(0,0);
		}		
		
		this.prevShowCategory = ( this.state.showAll || this.catalogLevel > 0 );

		if ( prevState.fetchSerial != this.state.fetchSerial )
		{
			this.fetchBrowseInfo();
			if ( this.state.showAll || this.catalogLevel > 0 ) 
			{
				if (this.sidebar) {
					this.sidebar.style.position 	= '';
					this.sidebar.style.transform 	= '';
				}
				window.scrollTo(0, 0); 
			}
		} 

		if ( this.state.colorGroupSelected != 0 ) 
		{
			document.addEventListener( 'click', this.clickOutColorGroupSelector );
		}
		else
		{
			document.removeEventListener( 'click', this.clickOutColorGroupSelector );
		}

		const active = document.querySelectorAll('.sidenav-tree__group-item-children-item--active')[0] || document.querySelectorAll('.sidenav-tree__group-item-title--active')[0];
		
		if(active) {
			active.scrollIntoView(true);
		}
		
	}

	clickOutColorGroupSelector = (event) => {
		const isColorGroupSelector = $(event.target).closest(this.colorGroupSelector).length == 1;

		if ( !isColorGroupSelector && this.state.colorGroupSelected ) 
			this.setState( {colorGroupSelected: 0} );
	}

	initWindowSizeMenu() 
	{
		window.addEventListener(
			'resize'
		,	() => 
			{
				if ( this.state.showCategoryMenu && window.innerWidth > 840 )
				{
					this.toggleCategoryMenu(false);
					ToggleScroll(false);
				}
			}
		);
	}

	sizeSidebar() {
		const sidebar = this.sidebar;

		imagesLoaded(
			this.container
			, function() {

				if(sidebar) { 
					const padding 				= 12;
					const footer 					= document.getElementById('bl-footer');
					const header 					= document.getElementById('bl-header').querySelector('.header');
					const headerHeight 		= header.offsetHeight;
					const footerTop 			= footer.offsetTop;
					const availableHeight = footerTop - headerHeight - (padding * 4);
					const visibleHeight 	= window.innerHeight - headerHeight - (padding * 4);

					sidebar.style.height 	= (availableHeight > visibleHeight ? visibleHeight : availableHeight) + 'px';
				}
			}
		);
	}

	initStickySidebar() {
		const _this = this;
		_this.sizeSidebar();

		imagesLoaded(
			this.container
		,	function() 
			{
				const sidebar 	= _this.sidebar;
				const footer 		= document.getElementById('bl-footer');
				const footerTop = footer.offsetTop;
				const padding 	= 12;

				function triggerStickySidebar() {
					const sidebarHeight		= sidebar.offsetHeight;
					const sidebarTop 			= sidebar.offsetTop;
					const sidebarFullSize = sidebarHeight + sidebarTop;
					const currentScroll 	= Math.round(window.scrollY);

					if(!_this.state.isMobile) {

						if (sidebarFullSize + currentScroll + padding > footerTop){
							sidebar.style.position 	= 'absolute';
							sidebar.style.transform	= `translateY(${footerTop - sidebarFullSize - padding}px)`;
						}else {
							sidebar.style.position 	= '';
							sidebar.style.transform = '';
						}
					}
				}

				

				if(sidebar) {
					triggerStickySidebar();
					window.addEventListener( 'scroll', triggerStickySidebar );
				}
			}
		);
	}

	render() 
	{
		const showCatBar = ( this.catalogLevel > 0 || this.state.showAll )
		return (
			<div className="main">
				{this.state.showSearchModal ? this.renderPartsSearchModal() : null}
				<div ref={container => this.container = container} className="main__content cat-browse__content">
					{ showCatBar ? this.renderCatBar() : null}
					{
						(!this.browseInfo || !this.browseInfo.dmBaseCategory) ?
						<main className={"cat-browse__main"  + (!showCatBar ? ' cat-browse__main--init' : '')}>	
							<div className="l-pad--xxl text--center section-title" style={{height: "500px"}}>
								Content Not Found!
							</div>
						</main>
						:
						<main className={"cat-browse__main"  + (!showCatBar ? ' cat-browse__main--init' : '')}>	
							{this.renderContent()}
						</main>
					}
				</div>
			</div>
		);
	}

	renderCatBar() 
	{
		const cateItems	= this.state.cateItems

		let buildGroupMenu = 
			(group) => 
			{
				return (
					_.map(
						group
					,	(item) => 
						{
							let		classNameBuild	= "";
							const	hasChild		= !_.isEmpty(item._arrItems);
							const	isActive		= item._item.strCatStr == this.state.selectedCatStr || item._arrItems.find(item => item._item.strCatStr == this.state.selectedCatStr) != null;

							if (isActive)
								classNameBuild += ' sidenav-tree__group-item-title--active';

							if(item._arrItems.find(item => item._item.strCatStr == this.state.selectedCatStr)) {
								classNameBuild += ' sidenav-tree__group-item-title--child-active'
							}

							return (
								<li key={item._item.strCatStr} className="sidenav-tree__group-item">
									<div className={"sidenav-tree__group-item-title" + classNameBuild}>
										<div className="l-full-width" onClick={() => this.updateCategory( item._item.strCatStr, true )}><span>{item.strName}</span><span className="l-margin-left--sm">({blapp.format.formatNumber(item._cnt)})</span></div>
									</div>
									{
										hasChild ?
										<ul className="sidenav-tree__group-item-children">
											{
												item._arrItems.map(
													(ic) =>
													<li key={ic._item.strCatStr} className={"sidenav-tree__group-item-children-item" + ((ic._item && ic._item.strCatStr == this.state.selectedCatStr) ? ' sidenav-tree__group-item-children-item--active' : '')}>
														<div className="l-full-width" onClick={() => this.updateCategory(ic._item.strCatStr, true)}><span>{ic.strName}</span><span className="l-margin-left--sm">({blapp.format.formatNumber(ic._cnt)})</span></div>
													</li>
												)
											}
										</ul>
										: 
										null
									}
								</li>							
							)
						}
					)
				);
			};

		const currentSidebar 	= cateItems;
		const catChildren 		= currentSidebar._arrItems.reduce((itemA, itemB) => itemA + itemB._arrItems.length + itemB._arrItems.reduce((itemA, itemB) => itemA + itemB._arrItems.length + itemB._arrItems.reduce((itemA, itemB) => itemA + itemB._arrItems.length + itemB._arrItems.reduce((itemA, itemB) => itemA + itemB._arrItems.length, 0), 0), 0), 0); 

		return (
			<React.Fragment>
				<aside ref={sidebar => this.sidebar = sidebar} className={"cat-browse__sidebar" + (this.state.showCategoryMenu ? ' cat-browse__sidebar--active' : '')}>
					<ul className="sidenav-tree">
						<h3 className="sidenav-tree__title text--small-title text--bold" style={{ cursor: "pointer" }} onClick={()=>this.updateCategory( this.typeItem + ":", true, true )}>{currentSidebar.strName} ({blapp.format.formatNumber(currentSidebar._cnt)})</h3>
						<ul id="js-sidenav-tree" className="sidenav-tree__group">
							<div className="cat-browse__sidebar-group">
								{buildGroupMenu(currentSidebar._arrItems)}
							</div>
						</ul>
					</ul>						
				</aside>
				{this.state.showCategoryMenu ? <div className="cat-browse__sidebar-overlay" onClick={() => this.toggleCategoryMenu(false)}/> : null}
			</React.Fragment>
		);
	}	

	renderContent() 
	{
		switch ( this.typeItem )
		{
			case "P":	return this.renderPartsContent();
			case "S":	return this.renderSetsContent();
			case "M":	return this.renderMinifigsContent();
		}

		return null;
	}

	renderPartsContent() 
	{
		const	curCate			= this.browseInfo.dmBaseCategory;
		const	parentStrCat	= blapp.category.getParentCatStr(curCate.strCatStr);
		const	catID			= blapp.category.getLastCatID(curCate.strCatStr);
		const	catParentID		= parentStrCat ? blapp.category.getLastCatID(parentStrCat) : null;
		const	catInfo			= catID > 0 ? blapp.category.getV2(catID) : blapp.category.getV2Root( this.typeItem );
		const	catParentInfo	= catParentID > 0 ? blapp.category.getV2(catParentID) : null;
		const	categoryItems	= this.renderCategoryListItems();
		let		catalogItems	= [];

		if ( this.browseInfo.arrItems ) 
		{
			let	cFilter	= [];

			_.forEach( this.state.selectedColors, (v, k) => { if( v > 0 ) cFilter.push( parseInt(k) ); } );

			if ( this.state.listType == 'card' ) 
			{
				_.forEach( 
					this.browseInfo.arrItems
				,	( item ) =>
					{
						catalogItems.push(
							<PartColorCard 
								key={item.dmItem.idItem} 
								classes="product-card--catalog product-card--catalog-part mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-desktop-l mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone" 
								data={PartColorCard.getDataFromBLMCatalogItemWithColor( item, "T2" )}
								wantedList={PartColorCard.getWantedListEnableInfo( item, { location: blapp.srcmap.LOCATION.CATALOG_XP } )}
								colorFilter={cFilter}
								inlineChildren={this.catalogLevel != 0}
								overrideDrawer={this.state.openCard == item.dmItem.idItem}
								drawerFunction={() => this.drawerFunction(item.dmItem.idItem)}
							/>
						);
					}
				);
			}
			else
			{
				_.forEach(
					this.browseInfo.arrItems
				,	( item ) =>
					{
						catalogItems.push(
							<PartColorListingItem 
								key={item.dmItem.idItem} 
								classes="cat-browse__item-listing"
								data={PartColorListingItem.getDataFromBLMCatalogItemWithColor( item, "T2" )}
								wantedList={PartColorListingItem.getWantedListEnableInfo( item, { location: blapp.srcmap.LOCATION.CATALOG_XP } )}
								colorFilter={cFilter}
								overrideDrawer={this.state.openCard == item.dmItem.idItem}
								drawerFunction={() => this.drawerFunction(item.dmItem.idItem)}
							/>
						);
					}
				);
			}
		}

		const 	showCategoryOnly	= this.catalogLevel == 0 && !this.state.showAll
		const 	isHeaderDark 			= curCate.strTxtColorHex === null || curCate.strTxtColorHex === 'FFFFFF'; // If the header background color is dark then we need to add a class to lighten content
		const 	headerBgColor 		= curCate.strBgColorHex || '0788CA';

		let		selColors			= _.map( this.state.selectedColors, ( v, k ) => k );

		selColors.sort();

		return (
			<section>
				{
					showCategoryOnly ?
						<header className="edge-to-edge-container cat-browse__cat-landing-head cat-browse__cat-landing-head--parts">
							<div className="edge-to-edge-container__internal edge-to-edge-container__internal--tight-mob l-relative">
								<div className="cat-browse__cat-landing-head-content cat-browse__cat-landing-head-content--parts">
									<p className="cat-browse__cat-landing-head-sub">Catalog</p>
									<h2 className="cat-browse__cat-landing-head-title">Browse dozens of categories and more than 50,000 LEGO&reg; parts in our catalog.</h2>
									<div className="cat-browse__cat-landing-head-foot">
										<p>Know what you're looking for? <button className="cat-browse__cat-landing-head-btn" onClick={() => this.toggleSearchModal()}>Find parts via set ID or name</button></p>
									</div>
								</div>
								<div className="cat-browse__cat-landing-head-image cat-browse__cat-landing-head-image--parts">
									<img src={"//" + blapp.config.getHost( "static2" ) + "/img/catalog-browse/browse-head-part.png"} alt="Disney's Rex the dinosaur"/>
								</div>
							</div>
						</header>
					:
					<React.Fragment>
						{this.renderBreadcrumbs()}
						{this.state.showAll ?
							<div className="cat-browse__show-all-head cat-browse__show-all-head--parts">
								<div>
									<h1 className="cat-browse__show-all-head-title cat-browse__show-all-head-title--with-sub">Browse all parts</h1>
									<p>Know what you're looking for? <button className="cat-browse__cat-landing-head-btn" onClick={() => this.toggleSearchModal()}>Find parts via set ID or name</button></p>
								</div>
								<div className="cat-browse__show-all-head-image cat-browse__show-all-head-image--parts">
									<img src={"//" + blapp.config.getHost( "static2" ) + "/img/catalog-browse/browse-head-part.png"} alt="Disney's Rex the dinosaur"/>
								</div>
							</div>
						:
							<div className={`cat-browse__generic-head ${isHeaderDark ? ' cat-browse__generic-head--dark' : ''}`} style={{backgroundColor: `#${headerBgColor}`}}>
								<h1 className="text--xl-title">{catInfo.strName}</h1>
								{this.renderSearchTrigger('parts')}
							</div>
						}
					</React.Fragment>
				}

				<div className="cat-browse__item-head l-flex l-margin-bottom">
					{showCategoryOnly ? 
						<div className="search-lockup search-lockup--bordered cat-browse__item-head-search">
							<div className="search-lockup__input-container">
								<input type="text" className="search-lockup__input search-lockup__input--start" placeholder={'Search all parts'} value={this.state.filterKeyword} onChange={(e) => this.setState({filterKeyword: e.target.value})} onKeyUp={(e)=>this.onSearchInputKeyUp(e)}/>
								{this.state.filterKeyword ? <button className="search-lockup__btn--clear" onClick={() => this.setState({filterKeyword: ''})}><i className="fas fa-times-circle"/></button> : null}
							</div>
							<button className="search-lockup__btn search-lockup__btn--end" onClick={() => this.submitSearch()}>
								<i className="far fa-search search-lockup__btn-icon"/>
							</button>
						</div>
					:
						<React.Fragment>
							<div className="search-lockup search-lockup--bordered cat-browse__item-head-search">
								<button className="search-lockup__btn search-lockup__btn--start">
									<i className="far fa-search search-lockup__btn-icon"></i>
								</button>
								<div className="search-lockup__input-container">
									<input type="text" className="search-lockup__input l-border-left--null" placeholder={'Filter parts by keyword'} value={this.state.filterKeyword} onClick={(e) => e.preventDefault()} onChange={(e) => this.updateFilterKeyword(e.target.value)} onKeyUp={(e)=>this.onInputKeyUp(e)}/>
									{this.state.filterKeyword ? <button className="search-lockup__btn--clear" onClick={() => this.updateFilterKeyword('',true)}><i className="fas fa-times-circle" onClick={()=>this.setState({fetchSerial: this.state.fetchSerial + 1})} /></button> : null}
								</div>
								<button className="search-lockup__btn search-lockup__btn--end search-lockup__btn--with-border l-flex l-center" onClick={() => this.setState({partFilter: !this.state.partFilter})}>
									<i className={`fa-fw ${this.state.partFilter ? "far fa-times" : "fas fa-filter"}`}/><span className="l-hide--small l-margin-left--sm">{this.state.partFilter ? 'Hide' : 'Show'} filters</span>
								</button>
							</div>
							<div className="sort-lockup cat-browse__item-head-sort">
								<button className="btn sort-lockup__direction" onClick={() => this.toggleSortDirection()}>
									<i className={"fas " + (this.state.sortDirection == -1 ? 'fa-sort-amount-down' : 'fa-sort-amount-up')}/>
								</button>
								<select className="select sort-lockup__select" value={this.state.sortType} onChange={(e) => this.updateSortType( e.target.value )}>
								{ _.map( [ 0, 1, 2, 3, 4, 5, 9, ], ( i ) => <option key={i} value={i}>{this.getSortOrderInfo(i)}</option> ) }
								</select>
							</div>
						</React.Fragment>
					}
				</div>

				{ !showCategoryOnly && this.state.partFilter ? this.renderPartFilter() : null }

				{
					!this.state.partFilter && ( !_.isEmpty(this.state.selectedColors) || this.state.selectedStudY || this.state.selectedStudX || this.state.selectedDecoration !== 'Any' || this.state.activeElementsOnly ) ?
					<ul className="l-margin-bottom--xl">
						<HiddenScroll>
							{
								this.state.filterKeyword ?
								<li className="pill pill--round pill--grey text-color--black l-margin-right">
									Keyword: {this.state.filterKeyword}
									<button className="btn btn--blank l-margin-left" onClick={() => this.updateFilterKeyword('',true)}><i className="fas fa-times-circle"/></button>
								</li>
								:
								null
							}
							{
								!_.isEmpty( selColors ) ?
								_.map(
									selColors
								,	( c ) =>
									{
										const cinfo	= blapp.color.get( c );

										return (
											<li className="pill pill--round pill--grey text-color--black l-margin-right">
												Color: {cinfo.strColorName}
												<button className="btn btn--blank l-margin-left" onClick={() => this.removeColorFilter( c )}><i className="fas fa-times-circle"/></button>
											</li>
										);
									}
								)
								:
								null
							}
							{
								this.state.selectedStudY || this.state.selectedStudX ? 
								<li className="pill pill--round pill--grey text-color--black l-margin-right">
									Studs: {`${this.state.selectedStudY ? this.state.selectedStudY : 'Any'} x ${this.state.selectedStudX ? this.state.selectedStudX : 'Any'}`}
									<button className="btn btn--blank l-margin-left" onClick={() => this.updateStudSize(0, 0, true)}><i className="fas fa-times-circle"/></button>
								</li>
								: 
								null
							}
							{
								this.state.selectedDecoration != 'Any' ?
								<li className="pill pill--round pill--grey text-color--black l-margin-right">
									Decorated: {this.state.selectedDecoration}
									<button className="btn btn--blank l-margin-left" onClick={() => this.updateSelectedDecoration('Any')}><i className="fas fa-times-circle"/></button>
								</li>
								:
								null
							}
							{
								this.state.activeElementsOnly != 0 ? 
								<li className="pill pill--round pill--grey text-color--black l-margin-right">
									Active elements only
									<button className="btn btn--blank l-margin-left" onClick={() => this.updateActiveElements(false)}><i className="fas fa-times-circle"/></button>
								</li>
								:
								null
							}
							<li>
								<button className="btn btn--link" onClick={() => this.removeFilters()}>Reset filters</button>
							</li>
						</HiddenScroll>
					</ul>
					: 
					null
				}
				<div className="l-flex l-margin-top--xl">
					<strong className="text--small-title text--bold cat-browse__item-head-title l-margin-right">
					{
						!showCategoryOnly ?
							`${blapp.format.formatNumber(this.browseInfo.nTotalItemCnt)} ${(this.browseInfo.nTotalItemCnt > 1 ? 'parts' : 'part')}`
						: 
							`${blapp.format.formatNumber(this.browseInfo.arrCategories.length)} ${(this.browseInfo.arrCategories.length > 1 ? 'categories' : 'category')}`
					}
					</strong>
					{
						!showCategoryOnly ?
						<div className="btn-group btn-group--split btn-group--auto-width btn-group--fill cat-browse__item-head-toggle">
							<button className={"btn-group__item l-pad--sm btn" + (this.state.listType == 'card' ? ' btn-group__item--active' : '')} onClick={this.state.listType != 'card' ? () => this.setState({listType: 'card'}) : null}><i className="far fa-fw fa-th-large"/></button>
							<button className={"btn-group__item l-pad--sm btn" + (this.state.listType == 'list' ? ' btn-group__item--active' : '')} onClick={this.state.listType != 'list' ? () => this.setState({listType: 'list'}) : null}><i className="fas fa-fw fa-list"/></button>
						</div>
						: 
						<button className="btn btn--link" onClick={()=>this.doShowAll()}>Browse all parts</button>
					}
				</div>
				{
					!_.isEmpty(categoryItems) && showCategoryOnly ?
					<div className="mdc-layout-grid l-pad-x--null">
						<div className="mdc-layout-grid__inner">
							{categoryItems}
						</div>
					</div>
					:
					<div className="l-pad-y">
						{
							_.isEmpty(catalogItems) ?
							<div className="l-pad l-flex l-column l-center l-border--top">
								<BrickheadMeh large={true} classes="l-margin-top--xl"/>
								<div className="l-margin-top">No items found!</div>
							</div>
							: 
							(	
								this.state.listType == 'card' ?
								<div className="mdc-layout-grid l-pad--null">
									<Pagination containerClasses={'mdc-layout-grid__inner l-relative'} data={{postsPerPage: this.state.postsPerPage, currentPage: this.state.currentPage, totalItemCnt: this.browseInfo.nTotalItemCnt, changePageCallback: ( p ) => this.onPageChange( p )}}>
										{catalogItems}
									</Pagination>
								</div>
								: 
								<Pagination containerClasses={"l-border--top"} data={{postsPerPage: this.state.postsPerPage, currentPage: this.state.currentPage, totalItemCnt: this.browseInfo.nTotalItemCnt, changePageCallback: ( p ) => this.onPageChange( p ) }}>
									{catalogItems}
								</Pagination>
							)
						}
					</div>
				}
			</section>
		);
	}

	drawerFunction(itemId) 
	{
		if(itemId == this.state.openCard) {
			this.setState({openCard: -1})
		}else{
			this.setState({openCard: itemId});
		}
	}

	renderSetsContent() 
	{
		const	curCate				= this.browseInfo.dmBaseCategory;
		const	parentStrCat	= blapp.category.getParentCatStr(curCate.strCatStr);
		const	catID			= blapp.category.getLastCatID(curCate.strCatStr);
		const	catInfo			= catID > 0 ? blapp.category.getV2(catID) : blapp.category.getV2Root( this.typeItem );
		const	categoryItems	= this.renderCategoryListItems();
		let		catalogItems	= [];

		if ( this.browseInfo.arrItems ) 
		{
			if ( this.state.listType == 'card' ) 
			{
				catalogItems	=	this.browseInfo.arrItems.map(
										(item, key) => 
										<ProductCard 
											key={item.dmItem.idItem} 
											ratioHeight
											classes="product-card--catalog mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-4-desktop-l mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone" 
											data={ProductCard.getDataFromBLMCatalogItemWithColor(item,"T2")} 
											wantedList={ProductCard.getWantedListEnableInfo(item,{location:blapp.srcmap.LOCATION.CATALOG_XP})}
											qtyCheckEnabled={true}
											titleLineCnt={2}
										/>
									);
			}
			else
			{
				catalogItems 	=	this.browseInfo.arrItems.map(
										(item, key) => 
										<ProductListingItem 
											size={'large'} 
											classes="cat-browse__item-listing"
											key={item.dmItem.idItem}
											data={ProductListingItem.getDataFromItemWithColor(item)}
											wantedList={ProductListingItem.getWantedListEnableInfo(item,{ location: blapp.srcmap.LOCATION.CATALOG_XP })}
											counters={{sets: item.dmItem.nSetCnt, parts: item.dmItem.nPartCnt, minifigures: item.dmItem.nFigCnt}}
										/>
									);
			}
		}

		const 	showCategoryOnly	= this.catalogLevel == 0 && !this.state.showAll;
		const 	isHeaderDark 			= curCate.strTxtColorHex === null || curCate.strTxtColorHex === 'FFFFFF'; // If the header background color is dark then we need to add a class to lighten content
		const 	headerBgColor 		= curCate.strBgColorHex || '0788CA';

		return (
			<section>
				{
					showCategoryOnly ?
						<header className="edge-to-edge-container cat-browse__cat-landing-head cat-browse__cat-landing-head--sets">
							<div className="edge-to-edge-container__internal edge-to-edge-container__internal--tight-mob l-relative">
								<div className="cat-browse__cat-landing-head-content cat-browse__cat-landing-head-content--sets">
									<p className="cat-browse__cat-landing-head-sub">Catalog</p>
									<h2 className="cat-browse__cat-landing-head-title">Discover rare LEGO&reg; sets or check out today’s most popular themes.</h2>
								</div>
								<div className="cat-browse__cat-landing-head-image cat-browse__cat-landing-head-image--sets">
									<img src={"//" + blapp.config.getHost( "static2" ) + "/img/catalog-browse/browse-head-sets.png"} alt="LEGO Coffee shop set"/>
								</div>
							</div>
						</header>
					:
					<React.Fragment>
						{this.renderBreadcrumbs()}
						{this.state.showAll ?
							<div className="cat-browse__show-all-head cat-browse__show-all-head--sets">
								<h1 className="cat-browse__show-all-head-title">Browse all sets</h1>
								<div className="cat-browse__show-all-head-image cat-browse__show-all-head-image--sets">
									<img src={"//" + blapp.config.getHost( "static2" ) + "/img/catalog-browse/browse-head-sets.png"} alt="LEGO Coffee shop set"/>
								</div>
							</div>
						:
							<div className={`cat-browse__generic-head ${isHeaderDark ? ' cat-browse__generic-head--dark' : ''}`} style={{backgroundColor: `#${headerBgColor}`}}>
								<h1 className="text--xl-title">{catInfo.strName}</h1>
							</div>
						}
					</React.Fragment>
				}
				<div className="cat-browse__item-head">
					{showCategoryOnly ? 
						<div className="search-lockup search-lockup--bordered cat-browse__item-head-search">
							<div className="search-lockup__input-container">
								<input type="text" className="search-lockup__input search-lockup__input--start" placeholder={'Search all sets'} value={this.state.filterKeyword} onChange={(e) => this.setState({filterKeyword: e.target.value})} onKeyUp={(e)=>this.onSearchInputKeyUp(e)}/>
								{this.state.filterKeyword ? <button className="search-lockup__btn--clear" onClick={() => this.setState({filterKeyword: ''})}><i className="fas fa-times-circle"/></button> : null}
							</div>
							<button className="search-lockup__btn search-lockup__btn--end" onClick={() => this.submitSearch()}>
								<i className="far fa-search search-lockup__btn-icon"/>
							</button>
						</div>
					:
						<React.Fragment>
							<div className="search-lockup search-lockup--bordered cat-browse__item-head-search">
								<button className="search-lockup__btn search-lockup__btn--start">
									<i className="far fa-search search-lockup__btn-icon"></i>
								</button>
								<div className="search-lockup__input-container">
									<input type="text" className="search-lockup__input l-border-left--null" placeholder={'Filter sets by keyword'} value={this.state.filterKeyword} onClick={(e) => e.preventDefault()} onChange={(e) => this.updateFilterKeyword(e.target.value)} onKeyUp={(e)=>this.onInputKeyUp(e)}/>
									{this.state.filterKeyword ? <button className="search-lockup__btn--clear" onClick={() => this.updateFilterKeyword('',true)}><i className="fas fa-times-circle" onClick={()=>this.setState({fetchSerial: this.state.fetchSerial + 1})} /></button> : null}
								</div>
								<button className="search-lockup__btn search-lockup__btn--end search-lockup__btn--with-border l-flex l-center" onClick={() => this.setState({showFilters: !this.state.showFilters})}>
									<i className={`fa-fw ${this.state.showFilters ? "far fa-times" : "fas fa-filter"}`}/><span className="l-hide--small l-margin-left--sm">{this.state.showFilters ? 'Hide' : 'Show'} filters</span>
								</button>
							</div>
							<div className="sort-lockup cat-browse__item-head-sort">
								<button className="btn sort-lockup__direction" onClick={() => this.toggleSortDirection()}>
									<i className={"fas " + (this.state.sortDirection == -1 ? 'fa-sort-amount-down' : 'fa-sort-amount-up')}/>
								</button>
								<select className="select sort-lockup__select" value={this.state.sortType} onChange={(e) => this.updateSortType( e.target.value )}>
									{ _.map( [ 0, 1, 2, 3, 4, 6, 7, 8, 9 ], ( i ) => <option key={i} value={i}>{this.getSortOrderInfo(i)}</option> ) }
								</select>
							</div>
						</React.Fragment>
					}
				</div>

				{
					this.state.showFilters ? 
					<div className="cat-browse__set-filter">
						{this.renderYearSelector()}
						<div className="cat-browse__set-filter-row">
							<div className="cat-browse__set-filter-group">
								<label className="cat-browse__set-filter-group-label" htmlFor="part-count">Part count:</label>
								<select className="select select--tight" id="part-count" value={this.state.selectedPartCount} onChange={(e) => this.updatePartCount(e.target.value)}>
								{
									_.map( 
										[ 0, 1, 2, 3, 4, 5, 6, 7 ]
									,	( idx ) =>
										<option value={idx}>{this.getPartsCountInfo( idx ).t}</option>	
									)
								}
								</select>
							</div>
							
							<div className="cat-browse__set-filter-group">
								<label className="cat-browse__set-filter-group-label" htmlFor="packaging-type">Packaging type:</label>
								<label className="l-margin-right l-flex l-center l-hide--small">
									<CustomRadio classes="l-margin-right--sm" value="Any" isChecked={this.state.selectedPackaging === 'Any'} onChangeFunc={() => this.updatePackaging('Any')}/>
									Any
								</label>
								<label className="l-margin-right l-flex l-center l-hide--small">
									<CustomRadio classes="l-margin-right--sm" value="Box" isChecked={this.state.selectedPackaging === 'Box'} onChangeFunc={() => this.updatePackaging('Box')}/>
									Box set
								</label>
								<label className="l-margin-right l-flex l-center l-hide--small">
									<CustomRadio classes="l-margin-right--sm" value="Polybag" isChecked={this.state.selectedPackaging === 'Polybag'} onChangeFunc={() => this.updatePackaging('Polybag')}/>
									Polybag
								</label>
								<select className="select select--tight l-hide--desktop" id="packaging-type" value={this.state.selectedPackaging} onChange={(e) => this.updatePackaging(e.target.value)}>
									<option value={'Any'}>Any</option>
									<option value={'Box'}>Box</option>
									<option value={'Polybag'}>Polybag</option>
								</select>
							</div>

							<button className="btn btn--link cat-browse__set-filter-reset" onClick={() => this.removeFilters()}>Reset filters</button>
						</div>
					</div>
					:
					null
				}

				{
					!this.state.showFilters && ( this.state.selectedYear || this.state.selectedPartCount  || this.state.selectedPackaging != "Any" ) ?
					<ul className="l-margin-bottom--xl">
						<HiddenScroll>
							{
								this.state.selectedYear != 0 ?
								<li className="pill pill--round pill--grey text-color--black l-margin-right">
									Released in: {this.state.selectedYear}
									<button className="btn btn--blank l-margin-left" onClick={() => this.updateYear(0)}><i className="fas fa-times-circle"/></button>
								</li>
								:
								null
							}
							{
								this.state.selectedPartCount != 0 ? 
								<li className="pill pill--round pill--grey text-color--black l-margin-right">
									Part count: {this.getPartsCountInfo( this.state.selectedPartCount ).t}
									<button className="btn btn--blank l-margin-left" onClick={() => this.updatePartCount(0)}><i className="fas fa-times-circle"/></button>
								</li>
								:
								null
							}
							{
								this.state.selectedPackaging != 'Any' ?
								<li className="pill pill--round pill--grey text-color--black l-margin-right">
									Packaging type: {this.state.selectedPackaging}
									<button className="btn btn--blank l-margin-left" onClick={() => this.updatePackaging('Any')}><i className="fas fa-times-circle"/></button>
								</li>
								:
								null
							}
							<li>
								<button className="btn btn--link" onClick={() => this.removeFilters()}>Reset filters</button>
							</li>
						</HiddenScroll>
					</ul>
					: 
					null
				}

				<div className="l-pad-bottom">
					<div className="l-flex l-margin-bottom">
						<strong className="text--small-title text--bold cat-browse__item-head-title l-margin-right">
						{
							!showCategoryOnly ?
							`${blapp.format.formatNumber(this.browseInfo.nTotalItemCnt)} ${(this.browseInfo.nTotalItemCnt > 1 ? 'sets' : 'set')}`
							: 
							`${blapp.format.formatNumber(this.browseInfo.arrCategories.length)} ${(this.browseInfo.arrCategories.length > 1 ? 'themes' : 'theme')}`
						}
						</strong>
						{
							!showCategoryOnly ?
							<div className="btn-group btn-group--split btn-group--auto-width btn-group--fill cat-browse__item-head-toggle">
								<button className={"btn-group__item btn" + (this.state.listType == 'card' ? ' btn-group__item--active' : '')} onClick={this.state.listType != 'card' ? () => this.setState({listType: 'card'}) : null}><i className="far fa-th-large"/></button>
								<button className={"btn-group__item btn" + (this.state.listType == 'list' ? ' btn-group__item--active' : '')} onClick={this.state.listType != 'list' ? () => this.setState({listType: 'list'}) : null}><i className="fas fa-list"/></button>
							</div>
							: 
							<button className="btn btn--link" onClick={()=>this.doShowAll()}>Browse all sets</button>
						}
					</div>

					{
						_.isEmpty( catalogItems ) && !showCategoryOnly ?
						<div className="l-flex l-column l-center l-border--top">
							<BrickheadMeh large={true} classes="l-margin-top--xl"/>
							<div className="l-margin-top">No items found!</div>
						</div>
						:
						<div className="mdc-layout-grid l-pad-null">
						{
							showCategoryOnly ? 
							<div className="mdc-layout-grid__inner l-relative">
								{categoryItems} 
							</div>
							: 
							this.state.listType == 'card' ?
								<Pagination containerClasses={'mdc-layout-grid__inner l-relative'} data={{postsPerPage: this.state.postsPerPage, currentPage: this.state.currentPage, totalItemCnt: this.browseInfo.nTotalItemCnt, changePageCallback: ( p ) => this.onPageChange( p ) }}>
									{catalogItems}
								</Pagination>
								: 
								<Pagination containerClasses="l-border--top" data={{postsPerPage: this.state.postsPerPage, currentPage: this.state.currentPage, totalItemCnt: this.browseInfo.nTotalItemCnt, changePageCallback: ( p ) => this.onPageChange( p ) }}>
									{catalogItems}
								</Pagination>
						}
						</div>
					}
				</div>					
			</section>
		);		
	}

	renderMinifigsContent() 
	{
		const	curCate			= this.browseInfo.dmBaseCategory;
		const	parentStrCat	= blapp.category.getParentCatStr(curCate.strCatStr);
		const	catID			= blapp.category.getLastCatID(curCate.strCatStr);
		const	catInfo			= catID > 0 ? blapp.category.getV2(catID) : blapp.category.getV2Root( this.typeItem );
		const	categoryItems	= this.renderCategoryListItems();
		let		catalogItems	= [];

		if ( this.browseInfo.arrItems )
		{
			if ( this.state.listType == 'card' ) 
			{
				catalogItems	=	this.browseInfo.arrItems.map(
										(item, key) => 
										<ProductCard 
											key={item.dmItem.idItem} 
											ratioHeight
											classes="product-card--catalog mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-4-desktop-l mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone" 
											data={ProductCard.getDataFromBLMCatalogItemWithColor(item,"T2")} 
											wantedList={ProductCard.getWantedListEnableInfo(item,{location:blapp.srcmap.LOCATION.CATALOG_XP})}
											qtyCheckEnabled={true}
											titleLineCnt={2}
										/>
									);
			}
			else 
			{
				catalogItems	= 	this.browseInfo.arrItems.map(
										(item, key) => 
										<ProductListingItem 
											size={'large'} 
											classes="cat-browse__item-listing"
											key={item.dmItem.idItem}
											data={ProductListingItem.getDataFromItemWithColor(item)}
											wantedList={ProductListingItem.getWantedListEnableInfo(item,{ location: blapp.srcmap.LOCATION.CATALOG_XP })}
											counters={{sets: item.dmItem.nSetCnt, parts: item.dmItem.nPartCnt, minifigures: item.dmItem.nFigCnt}}
										/>
									);
			}
		}

		const 	showCategoryOnly	= this.catalogLevel == 0 && !this.state.showAll
		const 	isHeaderDark 			= curCate.strTxtColorHex === null || curCate.strTxtColorHex === 'FFFFFF'; // If the header background color is dark then we need to add a class to lighten content
		const 	headerBgColor 		= curCate.strBgColorHex || '0788CA';

		return (
			<section>
				{
					showCategoryOnly ?
						<header className="edge-to-edge-container cat-browse__cat-landing-head cat-browse__cat-landing-head--minifigs">
							<div className="edge-to-edge-container__internal edge-to-edge-container__internal--tight-mob l-relative">
								<div className="cat-browse__cat-landing-head-content cat-browse__cat-landing-head-content--minifigs">
									<p className="cat-browse__cat-landing-head-sub">Catalog</p>
									<h2 className="cat-browse__cat-landing-head-title">From citizens to superheroes, we have every LEGO&reg; minifigure you could possibly want.</h2>
									<div className="cat-browse__cat-landing-head-foot">
										<p>Know what you're looking for? <button className="cat-browse__cat-landing-head-btn" onClick={() => this.toggleSearchModal()}>Find minifigures via set ID or name</button></p>
									</div>
								</div>
								<div className="cat-browse__cat-landing-head-image cat-browse__cat-landing-head-image--minifigs">
									<img src={"//" + blapp.config.getHost( "static2" ) + "/img/catalog-browse/browse-head-minifigs.png"} alt="Ironman minifig"/>
								</div>
							</div>
						</header>
					:
					<React.Fragment>
						{this.renderBreadcrumbs()}
						{this.state.showAll ?
							<div className="cat-browse__show-all-head cat-browse__show-all-head--minifigs">
								<div>
									<h1 className="cat-browse__show-all-head-title">Browse all minifigures</h1>
									<p>Know what you're looking for? <button className="cat-browse__cat-landing-head-btn" onClick={() => this.toggleSearchModal()}>Find minifigures via set ID or name</button></p>
								</div>
								<div className="cat-browse__show-all-head-image cat-browse__show-all-head-image--minifigs">
									<img src={"//" + blapp.config.getHost( "static2" ) + "/img/catalog-browse/browse-head-minifigs.png"} alt="Ironman minifig"/>
								</div>
							</div>
						:
							<div className={`cat-browse__generic-head ${isHeaderDark ? ' cat-browse__generic-head--dark' : ''}`} style={{backgroundColor: `#${headerBgColor}`}}>
								<h1 className="text--xl-title">{catInfo.strName}</h1>
								{this.renderSearchTrigger('minifigures')}
							</div>
						}
					</React.Fragment>
				}
				{showCategoryOnly ?
					<div className="cat-browse__item-head cat-browse__item-head--minifig l-flex l-margin-bottom">
						<div className="search-lockup search-lockup--bordered cat-browse__item-head-search">
							<div className="search-lockup__input-container">
								<input type="text" className="search-lockup__input search-lockup__input--start" placeholder={'Search all minifigures'} value={this.state.filterKeyword} onChange={(e) => this.setState({filterKeyword: e.target.value})} onKeyUp={(e)=>this.onSearchInputKeyUp(e)}/>
								{this.state.filterKeyword ? <button className="search-lockup__btn--clear" onClick={() => this.setState({filterKeyword: ''})}><i className="fas fa-times-circle" onClick={()=>this.setState({fetchSerial: this.state.fetchSerial + 1})} /></button> : null}
							</div>
							<button className="search-lockup__btn search-lockup__btn--end" onClick={() => this.submitSearch()}>
								<i className="far fa-search search-lockup__btn-icon"/>
							</button>
						</div>
						<label className="cat-browse__minifig-dropdown">
							<strong>Looking for collectible minifigures?</strong>
							<select className="select select--tight cat-browse__minifig-dropdown-select" onChange={(e) => this.gotoMinifigSeries(e.target.value)}>
							{this.renderCollectibleMinifigOptions()}
							</select>
						</label>
					</div>
				: 
					<div className="cat-browse__item-head">
						<div className="search-lockup search-lockup--bordered cat-browse__item-head-search">
							<button className="search-lockup__btn search-lockup__btn--start">
								<i className="far fa-search search-lockup__btn-icon"></i>
							</button>
							<div className="search-lockup__input-container">
								<input type="text" className="search-lockup__input search-lockup__input--end" placeholder={'Filter minifigures by keyword'} value={this.state.filterKeyword} onClick={(e) => e.preventDefault()} onChange={(e) => this.updateFilterKeyword(e.target.value)} onKeyUp={(e)=>this.onInputKeyUp(e)}/>
								{this.state.filterKeyword ? <button className="search-lockup__btn--clear" onClick={() => this.updateFilterKeyword('', true)}><i className="fas fa-times-circle" onClick={()=>this.setState({fetchSerial: this.state.fetchSerial + 1})} /></button> : null}
							</div>
						</div>
						<div className="sort-lockup cat-browse__item-head-sort">
							<button className="btn sort-lockup__direction" onClick={() => this.toggleSortDirection()}>
								<i className={"fas " + (this.state.sortDirection == -1 ? 'fa-sort-amount-down' : 'fa-sort-amount-up')}/>
							</button>
							<select className="select sort-lockup__select" value={this.state.sortType} onChange={(e) => this.updateSortType( e.target.value )}>
							{_.map( [ 0, 1, 2, 3, 4, 9 ], ( i ) => <option key={i} value={i}>{this.getSortOrderInfo(i)}</option> )}
							</select>
						</div>
					</div>
				}
				<div className="l-flex l-margin-top--xl">
					<strong className="text--small-title text--bold cat-browse__item-head-title l-margin-right">
					{
						!showCategoryOnly ?
						`${blapp.format.formatNumber(this.browseInfo.nTotalItemCnt)} ${(this.browseInfo.nTotalItemCnt > 1 ? 'minifigures' : 'minifigure')}`
						: 
						`${blapp.format.formatNumber(this.browseInfo.arrCategories.length)} ${(this.browseInfo.arrCategories.length > 1 ? 'themes' : 'theme')}`
					}
					</strong>
					{
						!showCategoryOnly ?
						<div className="btn-group btn-group--split btn-group--auto-width btn-group--fill cat-browse__item-head-toggle">
							<button className={"btn-group__item btn" + (this.state.listType == 'card' ? ' btn-group__item--active' : '')} onClick={this.state.listType != 'card' ? () => this.setState({listType: 'card'}) : null}><i className="far fa-th-large"/></button>
							<button className={"btn-group__item btn" + (this.state.listType == 'list' ? ' btn-group__item--active' : '')} onClick={this.state.listType != 'list' ? () => this.setState({listType: 'list'}) : null}><i className="fas fa-list"/></button>
						</div>
						: 
						<button className="btn btn--link" onClick={()=>this.doShowAll()}>Browse all minifigures</button>
					}
				</div>
				{
					showCategoryOnly ?
					<div className="mdc-layout-grid l-pad-x--null">
						<div className="mdc-layout-grid__inner l-relative">
							{categoryItems}
						</div>
					</div>
					:
					<div className="l-pad-y">
					{
						_.isEmpty(catalogItems) ?
							<div className="l-pad-top l-flex l-column l-center l-border--top">
								<BrickheadMeh large={true}/>
								<div className="l-margin-top">No items found!</div>
							</div>
						: 
						(
							this.state.listType == 'card' ?
							<div className="mdc-layout-grid l-pad--null">
								<Pagination containerClasses={'mdc-layout-grid__inner l-relative'} data={{postsPerPage: this.state.postsPerPage, currentPage: this.state.currentPage, totalItemCnt: this.browseInfo.nTotalItemCnt, changePageCallback: ( p ) => this.onPageChange( p ) }}>
									{catalogItems}
								</Pagination>
							</div>
							: 
							<Pagination containerClasses={"l-border--top"} data={{postsPerPage: this.state.postsPerPage, currentPage: this.state.currentPage, totalItemCnt: this.browseInfo.nTotalItemCnt, changePageCallback: ( p ) => this.onPageChange( p ) }}>
								{catalogItems}
							</Pagination>
						)
					}
					</div>
				}
			</section>
		);		
	}

	renderCategoryListItems() 
	{
		let	categoryItems	= [];
		
		const cardClasses = this.typeItem == 'S' ? `catalog-category-card--${blapp.util.getTypeName(this.typeItem, true).toLowerCase()} mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-desktop-l mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone` : `catalog-category-card--${blapp.util.getTypeName(this.typeItem, true).toLowerCase()} mdc-layout-grid__cell mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-2-desktop-l mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone`;

		_.forEach(
			this.browseInfo.arrCategories
		,	(cat) => 
			{
				const 	catIDs 			= cat.strCatStr.substring(2).split(".");
				const 	catInfo			= blapp.category.getV2(catIDs[catIDs.length - 1]);
				const 	categoryImage 	= cat.strImgUrl || cat.strItemImgUrl || "https://placehold.it/366x86";
				const 	themeClassName	= catInfo.strName.toLowerCase().replace( /![a-zA-Z0-9]/g, '' ).replace(/ /g, '-');
				let		arrChilds		= [];

				_.forEach(
					cat.arrChilds
				,	( cat ) =>
					{
						arrChilds.push(
							{ 
								link:			""
							,	image:			cat.strImgUrl || cat.strItemImgUrl || 'https://www.placehold.it/400x300'
							,	name:			cat.cateInfo.strName
							,	childrenLength:	cat.nItemResultCnt
							,	onClickFunc:	() => this.updateCategory( cat.strCatStr, true )
							}
						);
					}
				);

				categoryItems.push(
					<CatalogCategoryCard
						key={cat.strCatStr} 
						classes={cardClasses} 
						data={{link: "", image: categoryImage, background: cat.strImgBgColorHex || false, name: catInfo.strName, cnt: cat.nItemResultCnt, showChildren: ( this.state.subCategoryOpen == cat.strCatStr ), onClickFunc: () => this.updateCategory(cat.strCatStr, true), onShowChildrenFunc: ( bShow ) => this.updateShowSubCategory( cat.strCatStr, bShow )}} 
						children={_.isEmpty( arrChilds ) ? null : arrChilds}
					/>
				);
			}
		);

		return categoryItems;
	}

	renderBreadcrumbs() 
	{
		if ( this.catalogLevel > 0 || this.state.showAll) 
		{
			const	curCate	= this.browseInfo.dmBaseCategory;
			const	catID	= blapp.category.getLastCatID( curCate.strCatStr );
			let 	crumbs 	= [];
			let		catStrBuild	= "" + this.typeItem + ":";

			crumbs.push( {content: blapp.util.getTypeName(this.typeItem, true), func: () => this.updateCategory(this.typeItem + ":", false)} );
		
			_.forEach(
				blapp.category.getV2ListByCatStr(curCate.strCatStr)
			,	(cat) => 
				{
					catStrBuild	+= (catStrBuild.length > 2 ? "." : "") + cat.idCateV2;

					let	catStrCopy = _.clone(catStrBuild);

					if ( cat.idCateV2 == catID ) 
						crumbs.push( {content: cat.strName} );
					else
						crumbs.push( {content: cat.strName, func: () => this.updateCategory( catStrCopy, false ) } );
				}
			);

			return (
				<div className="catalog-breadcrumbs">
					<button className="btn btn--link l-hide--desktop l-margin-right" onClick={() => this.toggleCategoryMenu(!this.state.showCategoryMenu)}><i className="far fa-folder-tree"/></button>
					<HiddenScroll classes="catalog-breadcrumbs__main">
						<BreadCrumbs type={'arrow'} crumbs={crumbs} clean={true}/>
					</HiddenScroll>
				</div>
			);
		}
	}

	renderColorGroupSelector() 
	{
		const	selectedGroup	= _.find(this.colorGroup, (cg) => (cg.idColorFamily == this.state.colorGroupSelected));
		let		selectedCnt		= 0;
		const	groupItems		=
			selectedGroup.colors.map(
				(c, idx) => 
				{
					const	isSelected 		= (this.state.selectedColors[c.idColor] == selectedGroup.idColorFamily);
					let		isIndeterminate = (this.state.selectedColors[c.idColor] > 0 && !isSelected);
			
					if ( isSelected ) ++selectedCnt;
				
					return (
						<li key={idx} className="cat-part-filter__color-group-item">
							<label className="l-flex l-center">
								<CustomCheckbox isDark={true} isIndeterminate={isIndeterminate} isChecked={isSelected} onChangeFunc={() => this.toggleColorGroupItem(selectedGroup, c)} classes="l-margin-right"/>
								<span className="l-full-width l-flex l-center">
									<i className="color-swatch color-swatch--rounded color-swatch--small l-border--null l-margin-right--sm" style={{backgroundColor: "#"+c.cInfo.strColorHex}}/>
									{c.cInfo.strColorName}
								</span>
								<span className="l-margin-left--sm">{c.nItemCount}</span>
							</label>
						</li>
					);
				}
			);

		const currentSelected 	= selectedGroup.idx + 2;
		const translateMax 		= this.colorGroup.length + 1;
		const translateAmount 	= this.state.colorGroupSelected > 0 ? ((currentSelected / translateMax) * 200) - 10 : 0;

		return (
			<div ref={colorGroupSelector => this.colorGroupSelector = colorGroupSelector} className="cat-part-filter__color-group" style={{transform: `translateX(${translateAmount}%)`}}>
				<ul className="cat-part-filter__color-group-items l-pad l-pad-top--null">
					{groupItems}
				</ul>
				<div className="cat-part-filter__color-group-footer l-border--top l-pad">
					<label className="l-flex l-center">
						<CustomCheckbox isDark={true} isChecked={selectedCnt == selectedGroup.colors.length} onChangeFunc={() => this.toggleAllColorGroupItem( selectedGroup )} classes="l-margin-right"/>Select all
					</label>
				</div>
			</div>
		);
	}

	renderPartFilter() 
	{
		let colorGroupItems = [];

		if ( this.colorGroup ) 
		{
			colorGroupItems = 
				this.colorGroup.map(
					(cg) => 
					{
						let	selectedCnt	= _.reduce( this.state.selectedColors, ( r, v, k ) => ( v == cg.idColorFamily ? r + 1 : r ), 0 );

						return(
							<div key={cg.idColorFamily} className={"cat-part-filter__color-swatch" + (this.state.colorGroupSelected == cg.idColorFamily ? ' cat-part-filter__color-swatch--active' : '')} style={{backgroundColor: "#" + cg.strRGB}} onClick={() => this.setState( {colorGroupSelected: ( this.state.colorGroupSelected == cg.idColorFamily ) ? 0 : cg.idColorFamily } )}>
								{selectedCnt ? <div><i className="fas fa-check-circle l-margin-right--xs"/>{selectedCnt}</div> : null}
							</div>
						);
					}
				);
		}

		const	selectedStudX = _.find(this.studGroup, (sg) => (sg.value == this.state.selectedStudX));
		const	studGroupY		= selectedStudX ? selectedStudX.yValues : [];

		if( _.isEmpty(colorGroupItems) && _.isEmpty(this.studGroup) && this.state.filterKeyword == "" && _.isEmpty(this.browseInfo.arrItems) ) 
			return null;

		return (
			<div className={"l-border--bottom l-margin-bottom l-pad-top l-pad-bottom--null " + (this.catalogLevel == 1 ? ' l-border--top' : '')}>
				{
					!_.isEmpty(colorGroupItems) &&
					<div className="l-border--bottom l-relative l-pad-bottom">
						<div className="cat-part-filter__colors">
							<div className="cat-part-filter__color-swatch cat-part-filter__color-swatch--all" onClick={() => this.clearAllColorGroups()}>
								All
							</div>
							{colorGroupItems}
						</div>
						{this.state.colorGroupSelected > 0 ? this.renderColorGroupSelector() : null}
					</div>
				}

				<div className={"cat-part-filter__item-filter" + (this.catalogLevel > 0 ? ' cat-part-filter__item-filter--item-level' : '')}>
					{	!_.isEmpty(this.studGroup) &&
						<div className="cat-part-filter__item-filter-item">
							<div className="l-margin-right cat-part-filter__item-filter-label">Stud size:</div>
							<div className="l-flex l-center cat-part-filter__item-filter-input">
								<select className="select select--tight cat-part-filter__item-filter-input" value={this.state.selectedStudX} onChange={(e) => this.updateStudSize(e.target.value, null)}>
									<option>Any</option>
									{this.studGroup.map((sg, key) => <option key={key}>{sg.value}</option>)}
								</select>
								<div className="l-pad-x">x</div>
								<select className="select select--tight cat-part-filter__item-filter-input" value={this.state.selectedStudY} disabled={selectedStudX == null} onChange={(e) => this.updateStudSize(null, e.target.value)}>
									<option>Any</option>
									{studGroupY.map((sg, key) => <option key={key}>{sg.value}</option>)}
								</select>
							</div>
						</div>
					}

					<div className="cat-part-filter__item-filter-item">
						<label className="l-margin-right cat-part-filter__item-filter-label" htmlFor="decoration-type">Decoration:</label>
						<label className="l-margin-right l-flex l-center l-hide--small">
							<CustomRadio classes="l-margin-right--sm" value="any" isChecked={this.state.selectedDecoration === 'Any'} onChangeFunc={() => this.updateSelectedDecoration('Any')}/>
							Any
						</label>
						<label className="l-margin-right l-flex l-center l-hide--small">
							<CustomRadio classes="l-margin-right--sm" value="plain" isChecked={this.state.selectedDecoration === 'Plain'} onChangeFunc={() => this.updateSelectedDecoration('Plain')}/>
							Plain
						</label>
						<label className="l-margin-right l-flex l-center l-hide--small">
							<CustomRadio classes="l-margin-right--sm" value="decorated" isChecked={this.state.selectedDecoration === 'Decorated'} onChangeFunc={() => this.updateSelectedDecoration('Decorated')}/>
							Decorated
						</label>
						<select className="select select--tight l-hide--desktop cat-part-filter__item-filter-input" id="decoration-type" value={this.state.selectedDecoration} onChange={(e) => this.updateSelectedDecoration(e.target.value)}>
							<option value={'Any'}>Any</option>
							<option value={'Plain'}>Plain</option>
							<option value={'Decorated'}>Decorated</option>
						</select>
					</div>

					<div className="cat-part-filter__item-filter-item cat-part-filter__item-filter-item--active-el">
						<div className="l-margin-right cat-part-filter__item-filter-label">Show:</div>
						<label className="l-flex l-center">
							<CustomCheckbox isDark={true} isChecked={this.state.activeElementsOnly} onChangeFunc={() => this.updateActiveElements(!this.state.activeElementsOnly)} classes="l-margin-right"/>
							Active elements only
						</label>
					</div>

					<div className="cat-browse__set-filter-reset">
						<button className="btn btn--link" onClick={() => this.removeFilters()}>Reset filters</button>
					</div>

					{	false && // For the future use
						<div className="cat-part-filter__item-filter-item">
							<div className="cat-part-filter__item-filter-label">Stud count:</div>
							<select className="select select--tight">
								<option>Any</option>
							</select>
						</div>
					}
				</div>
			</div>
		);
	}

	renderYearSelector() 	
	{
		let	years	= [];

		if ( this.browseInfo.mapYearInfo ) 
		{
			_.forEach(this.browseInfo.mapYearInfo, (v, k) => years.push(k));
			years.sort((l, r) => (r - l));
		}

		if( !_.isEmpty(years) ) 
		{
			return (
				<div className="l-border--bottom">
					<div className="l-flex">
						<div className="l-margin-right text--no-wrap">Released in:</div>
						<ul className="view-selector l-flex-min-width">
							<HiddenScroll>
								<li className={"view-selector__item l-pad-bottom" + (this.state.selectedYear == 0 ? " view-selector__item--active" : "")}>
									<span className="view-selector__item-content" onClick={this.state.selectedYear != 0 ? () => this.updateYear( 0 ) : null}>All years</span>
								</li>
								{
									years.map(
										(y) => 
										<li key={y} className={"view-selector__item l-pad-bottom" + (this.state.selectedYear == y ? " view-selector__item--active" : "")}>
											<span className="view-selector__item-content" onClick={this.state.selectedYear != y ? () => this.updateYear(y) : null}>{y}</span>
										</li>
									)
								}
							</HiddenScroll>
						</ul>
					</div>
				</div>
			);			
		}
	}

	renderSearchTrigger(type) 
	{
		return (
			<button className="cat-part-search l-margin-left--xl" onClick={() => this.toggleSearchModal()}>
				<i className="fas fa-book-open"/><span className="l-margin-left l-hide--small">Find {type} via set ID or name</span>
			</button>
		);
	}

	renderPartsSearchModal() 
	{
		return <SearchModalContent type={this.typeItem == 'M' ? 'minifigures' : 'parts'} closeFunc={() => this.toggleSearchModal()}/>
	}	

	toggleSearchModal() {
		blapp.screen.toggleScroll(!this.state.showSearchModal);

		this.setState({showSearchModal: !this.state.showSearchModal});
	}

	renderCollectibleMinifigOptions()
	{
		let	cmCates	= [];

		_.forEach(
			blapp.category.arrCategoryTreeV2
		,	( cat ) =>
			{
				if ( cat.strCatStr.startsWith( "S:5217." ) && cat.strCatStr.length == 11 )
					cmCates.push( cat );
			}
		);

		if ( !_.isEmpty( cmCates ) )
		{
			let	arr		= [];
			let	lastCat	= null;
			_.forEach( 
				cmCates
			,	( c ) =>
				{
					let	catID	= blapp.category.getLastCatID( c.strCatStr )

					if ( catID )
					{
						let	cInfo	= blapp.category.getV2( catID );

						if ( cInfo )
						{
							arr.push( { strCatStr: c.strCatStr, name: cInfo.strName } );

							if ( lastCat == null || c.nPopularity > lastCat.nPopularity )
							{
								lastCat	= c;
							}
						}
					}
				}
			);

			arr.sort( ( l , r ) => r.name.localeCompare( l.name, "en", { numeric: true } ) );
			arr.unshift( { strCatStr: "", name: "Select a series" } );

			return _.map( arr, ( o ) => <option value={o.strCatStr}>{o.name}</option> );
		}
	}

	traverseCateTree( cateTree, preFunc, postFunc )
	{
		if ( preFunc )
			preFunc( cateTree );

		if ( !_.isEmpty( cateTree._arrItems ) )
			_.forEach( cateTree._arrItems, ( ci ) => this.traverseCateTree( ci, preFunc, postFunc ) );

		if ( postFunc )
			postFunc( cateTree );

		return cateTree;
	}

	buildCateTree( cateMapInfo )
	{
		let	cateRoot	= {_mapItems:{}, _arrItems: [], idCateV2: 0, _strCatStr: this.typeItem, strName: blapp.util.getTypeName( this.typeItem, true ), _cnt: 0, _parent: null, _depth: 0};

		_.forEach(
			blapp.category.arrCategoryTreeV2
		,	( c ) =>
			{
				let	cnt = parseInt( cateMapInfo[ c.strCatStr ] );
				if ( cnt > 0 )
				{
					let	ci		= null;
					let	cc		= cateRoot;
					let	curStr	= c.strCatStr.substring( 0, 2 );

					_.forEach(
						blapp.category.getV2ListByCatStr( c.strCatStr )
					,	( cateV2 ) =>
						{
							ci	= cc._mapItems[ cateV2.idCateV2 ];

							curStr	+= cateV2.idCateV2 + ".";

							if ( ci == null )
							{
								ci	= { _mapItems:{}, _arrItems: [], _parent: cc, _cnt: 0, _depth: cc._depth + 1, _open: false, _active: false };
								ci._strCatStr	= curStr.substring( 0, curStr.length - 1 );
								ci._item		= c;
								ci.idCateV2		= cateV2.idCateV2;
								ci.strName		= cateV2.strName;

								cc._mapItems[ cateV2.idCateV2 ]	= ci;
								cc._arrItems.push( ci );
							}

							cc	= ci;
						}
					);

					cc._cnt			= cnt;
				}
			}
		);

		this.traverseCateTree(
			cateRoot
		,	( cat ) =>
			{
				cat._arrItems.sort( ( l, r ) => l.strName.localeCompare( r.strName, "en", { numeric: true } ) );
			}
		);

		cateRoot._cnt = parseInt( cateMapInfo[ this.typeItem + ":" ] || "0" );

		return cateRoot;
	}	

	buildFromBrowseInfo()
	{
		if ( this.browseInfo && this.browseInfo.dmBaseCategory )
		{
			this.typeItem		= this.browseInfo.dmBaseCategory.strCatStr.substring( 0, 1 );
			this.colorGroup		= this.buildColorGroup();
			this.studGroup		= this.buildStudGroup();
			this.catalogLevel 	= ( this.browseInfo.dmBaseCategory.strCatStr.length > 2 ) ? this.browseInfo.dmBaseCategory.strCatStr.split( "." ).length : 0;

			this.browseInfo.arrCategories	= this.getChildCateList( this.browseInfo.dmBaseCategory.strCatStr );
		}
	}

	getChildCateList( strCatStr )
	{
		let	arr		= [];
		
		if ( this.browseInfo.mapCateInfo )
		{
			let	prefix	= ( strCatStr.length == 2 ) ? strCatStr : ( strCatStr + "." );
			let plen	= prefix.length;

			_.forEach(
				this.browseInfo.mapCateInfo
			,	( v, k ) =>
				{
					if ( k.startsWith( prefix ) && k.indexOf( ".", plen ) == -1 )
					{
						let	cate	= _.clone( blapp.category.getV2TreeByCatStr( k ) );

						if ( cate )
						{
							cate.nItemResultCnt	= parseInt( v );
							cate.cateInfo		= blapp.category.getV2( blapp.category.getLastCatID( cate.strCatStr ) );
							cate.arrChilds		= this.getChildCateList( cate.strCatStr );
							arr.push( cate );
						}
					}
				}
			);
			arr.sort( ( l, r ) => l.cateInfo.strName.localeCompare( r.cateInfo.strName ) );
		}

		return arr;
	}

	getNewStateFromBrowseInfo()
	{
		if ( this.browseInfo && this.browseInfo.option )
		{
			const	option				= this.browseInfo.option;
			let		selectedStudX		= ""
			let		selectedStudY		= ""
			let		selectedColors		= {}
			let		decorationOption	= "Any";
			let		packagingOption		= "Any";
			let		selectedPartCount	= 0;
			let		subCategoryOpen		= ( blapp.util.getUrlVar( "so" ) ||this.state.subCategoryOpen );

			if ( option.strStudFilter )
			{
				let	vars	= option.strStudFilter.split( ":" );
				selectedStudX	= vars[ 0 ];
				selectedStudY	= vars.length > 1 ? vars[ 1 ] : "";
			}

			if ( option.strColorFilter )
			{
				_.forEach( 
					option.strColorFilter.split( "," ) 
				,	( val ) =>
					{
						let vars 			= val.split( ":" );

						if ( vars.length == 2 )
						{
							let	idColor			= parseInt( vars[ 0 ] );
							let idColorFamily	= parseInt( vars[ 1 ] );

							if ( idColor >= 0 && idColorFamily > 0 )
								selectedColors[ idColor ]	= idColorFamily;
						}
					}
				);
			}

			if ( option.strDecoFilter == "Y" )
				decorationOption	= "Decorated";
			else if ( option.strDecoFilter == "N" )
				decorationOption	= "Plain";

			if ( option.strPolyBagFilter == "Y" )
				packagingOption		= "Polybag";
			else if ( option.strPolyBagFilter == "N" )
				packagingOption		= "Box";

			for ( let i = 0; i <= 7; ++i )
			{
				let	pci	= this.getPartsCountInfo( i );

				if ( option.nPartsCntLower == pci.l )
				{
					selectedPartCount	= i;
					break;
				}
			}

			if ( subCategoryOpen != "" && !this.browseInfo.mapCateInfo[ subCategoryOpen ] )
				subCategoryOpen	= "";

			return (
				{
					selectedCatStr:		this.browseInfo.dmBaseCategory.strCatStr
				,	filterKeyword:		option.strFilterKeyword || ""
				
				,	selectedStudX:		selectedStudX
				,	selectedStudY:		selectedStudY
				,	selectedColors:		selectedColors
				,	selectedDecoration:	decorationOption

				,	selectedYear:		option.nYearFilter || 0
				,	selectedPackaging:	packagingOption
				,	selectedPartCount:	selectedPartCount

				,	sortType:			option.typeSort
				,	sortDirection:		option.bAsc ? 1 : -1
				,	subCategoryOpen:	subCategoryOpen
				,	showAll:			option.bShowTopLevelItems
				,	cateItems:			this.buildCateTree( this.browseInfo.mapCateInfo )
				,	currentPage:		option.nPageStart
				}
			);
		}

		return null;		
	}

	buildColorGroup()
	{
		if ( !this.browseInfo.mapColorInfo )
			return null;

		let	colorGroup	= [];

		_.forEach( 
			blapp.color.mapFamily
		,	( c ) => 
			{
				if ( c.idColorFamily == 1 )	// All color
					return;

				let	matchedColors	= [];

				_.forEach(
					c.arrColors
				,	( cc ) => 
					{
						cc	= parseInt( cc );
						const	itemCnt	= this.browseInfo.mapColorInfo[ cc ];
						if ( itemCnt > 0 )
							matchedColors.push( { idColor: cc, cInfo: blapp.color.get( cc ), nItemCount: itemCnt } );
					}
				);

				if ( !_.isEmpty( matchedColors ) )
				{
					colorGroup.push( { idx: colorGroup.length, idColorFamily: c.idColorFamily, strName: c.strName, strRGB: c.strRGBAHex.substring( 0, 6 ), colors: matchedColors } );
				}
			}
		);

		colorGroup.sort( ( l, r ) => l.idColorFamily - r.idColorFamily );

		return colorGroup;
	}

	buildStudGroup()
	{
		let	arrStud 		= null;

		if ( this.browseInfo.mapStudInfo )
		{
			let mapStud		= {};
			
			arrStud		= [];

			_.forEach(
				this.browseInfo.mapStudInfo
			,	( v, k ) =>
				{
					const 	vals	= k.split( ":" );
					const	x		= vals[ 0 ];
					const	y		= vals[ 1 ];
					let		list	= mapStud[ x ];

					if ( list == null )
					{
						list			= { value: x, yValues: [] };
						mapStud[ x ]	= list;
					}

					list.yValues.push( { value: y, cnt: v } );
				}
			);

			_.forEach( mapStud, ( v ) => { arrStud.push( v ); v.yValues.sort( ( l, r ) => parseFloat( l.value ) - parseFloat( r.value ) ); } );

			arrStud.sort( ( l, r ) => parseFloat( l.value ) - parseFloat( r.value ) );
		}

		return arrStud;
	}

	toggleCategoryMenu(state) 
	{
		this.setState({showCategoryMenu: state});

		ToggleScroll(!this.state.showCategoryMenu);
	}		

	toggleCateExpand( cateItem )
	{
		let	cateItems	= this.state.cateItems;
		let	curCI		= cateItem;

		if ( cateItem._open )
		{
			curCI._open	= false;
		}
		else
		{
			if ( curCI._parent != null )
				_.forEach( curCI._parent._arrItems, ( ci ) => { ci._open = false; } );

			curCI._open = true;
		}

		this.setState( { dummy: this.state.dummy + 1, cateItems: cateItems } );
	}

	toggleColorGroupItem( colorGroup, color ) 
	{
		this.state.selectedColors[ color.idColor ] = ( colorGroup.idColorFamily == this.state.selectedColors[ color.idColor ] ) ? 0 : colorGroup.idColorFamily;

		this.setState( { fetchSerial: this.state.fetchSerial + 1, selectedColors: this.state.selectedColors } );
	}

	toggleAllColorGroupItem( colorGroup ) 
	{
		let isAllSelected	= true;
		
		_.forEach( 
			colorGroup.colors
		,	( c ) => 
			{
				if ( !( this.state.selectedColors[ c.idColor ] > 0 ) )
					isAllSelected	= false;
			}
		);

		_.forEach( 
			colorGroup.colors
		,	( c ) => 
			{
				this.state.selectedColors[ c.idColor ]	= isAllSelected ? 0 : colorGroup.idColorFamily;
			}
		);

		this.setState( { fetchSerial: this.state.fetchSerial + 1, selectedColors: this.state.selectedColors } );
	}

	clearAllColorGroups() 
	{
		this.setState( { fetchSerial: this.state.fetchSerial + 1, selectedColors: {}, colorGroupSelected: 0 } );
	}

	removeFilters() 
	{
		this.setState(
			{
				fetchSerial:		this.state.fetchSerial + 1
			,	selectedColors:		{}
			,	selectedStudX:		""
			,	selectedStudY:		""
			,	selectedDecoration:	"Any"
			,	activeElementsOnly:	false
			,	selectedYear:		0
			,	selectedPartCount:	0
			,	selectedPackaging:	"Any"
			,	filterKeyword:		""
			,	showFilters:		false
			}
		)
	}

	removeColorFilter( idColor )
	{
		this.state.selectedColors[ idColor ]	= 0;
		this.setState( { fetchSerial: this.state.fetchSerial + 1, selectedColors: this.state.selectedColors } );
	}

	updateShowSubCategory( strCatStr, bShow )
	{
		if ( bShow )
		{
			this.setState( { subCategoryOpen: strCatStr } );
			window.history.replaceState( null, document.title, blapp.url2.getCurrentUrlWithMergedQS( "so=" + strCatStr ) );
		}
		else if ( this.state.subCategoryOpen == strCatStr )
		{
			this.setState( { subCategoryOpen: "" } );
			window.history.replaceState( null, document.title, blapp.url2.removeQSFromCurrentUrl( "so" ) );
		}
	}

	updateCategory( strCatStr, keepFilter, doShowAll )
	{
		this.setState(
			{
				fetchSerial:		this.state.fetchSerial + 1
			,	selectedCatStr: 	strCatStr
			,	currentPage:		1
			,	showAll:			doShowAll || this.state.showAll
			}
		);

		if ( !keepFilter )
			this.removeFilters();
	}

	updateFilterKeyword( newKeyword, bUpdateNow )
	{
		this.setState( { filterKeyword: newKeyword, fetchSerial: bUpdateNow ? this.state.fetchSerial + 1 : this.state.fetchSerial, currentPage: 1 } );
	}

	updateStudSize( newSizeX, newSizeY, clear = false )
	{
		this.setState( { fetchSerial: this.state.fetchSerial + 1, selectedStudX: clear ? null : (newSizeX ? newSizeX : this.state.selectedStudX), selectedStudY: clear ? null : (newSizeY ? newSizeY : this.state.selectedStudY) } );
	}

	updateSelectedDecoration( value ) 
	{
		if ( value != "Plain" && value != "Decorated" )
			value	= "Any";		
		this.setState( { fetchSerial: this.state.fetchSerial + 1, selectedDecoration: value } );
	}

	updateActiveElements(value) 
	{
		this.setState( {fetchSerial: this.state.fetchSerial + 1, activeElementsOnly: value } );
	}

	updateYear( newYear )
	{
		this.setState({fetchSerial: this.state.fetchSerial + 1, selectedYear: newYear });
	}

	updatePartCount(newPartCount) 
	{
		this.setState({fetchSerial: this.state.fetchSerial + 1, selectedPartCount: parseInt( newPartCount ) });
	}
	
	updatePackaging(newPackaging) 
	{
		if ( newPackaging != "Box" && newPackaging != "Polybag" )
			newPackaging	= "Any";
		this.setState({fetchSerial: this.state.fetchSerial + 1, selectedPackaging: newPackaging });
	}

	updateSortType( newSortType )
	{
		newSortType	= parseInt( newSortType );

		if ( newSortType >= 0 )
		{
			this.setState( { fetchSerial: this.state.fetchSerial + 1, sortType: newSortType, sortDirection: ( newSortType == 1 || newSortType == 2 ) ? 1 : -1 } );
		}
	}

	toggleSortDirection()
	{
		let	newDirection	= ( this.state.sortDirection == -1 ) ? 1 : -1;

		this.setState( { fetchSerial: this.state.fetchSerial + 1, sortDirection: newDirection } );
	}

	fetchBrowseInfo()
	{
		let	option	=	{
							strSearchQuery:			""
						,	strFilterKeyword:		this.state.filterKeyword
						,	nYearFilter:			this.state.selectedYear
						,	strColorFilter:			""
						,	strStudFilter:			""
						,	strDecoFilter:			""
						,	strPolyBagFilter:		""
						,	nPartsCntLower:			0
						,	nPartsCntUpper:			0
						,	typeSort:				this.state.sortType
						,	bAsc:					this.state.sortDirection == -1 ? false : true
						,	nPageStart:				this.state.currentPage
						,	nPageSize:				this.state.postsPerPage
						,	strCatFilter:			this.state.selectedCatStr
						,	bAvailableOnly:			false
						};

		if ( this.state.showAll && this.state.selectedCatStr.length == 2 )
			option.bShowTopLevelItems	= true;

		// Parts Filter
		if ( !_.isEmpty( this.state.selectedColors ) )
		{
			option.strColorFilter	= "";
			_.forEach(
				this.state.selectedColors
			,	( v, k ) => { if ( v > 0 ) option.strColorFilter += ( "," + k + ":" + v ); }
			);
			option.strColorFilter	= option.strColorFilter.length > 0 ? option.strColorFilter.substring( 1 ) : null;
		}

		if ( parseInt( this.state.selectedStudX ) >= 0 )
			option.strStudFilter	= "" + this.state.selectedStudX + ":" + this.state.selectedStudY;

		if ( this.state.selectedDecoration == "Plain" )
			option.strDecoFilter	= "N";
		else if ( this.state.selectedDecoration == "Decorated" )
			option.strDecoFilter	= "Y";

		if ( this.state.activeElementsOnly )
			option.bAvailableOnly	= true;

		// Set Filters
		if ( this.state.selectedYear > 0 )
			option.nYearFilter		= this.state.selectedYear;

		if ( this.state.selectedPackaging == "Box" )
			option.strPolyBagFilter	= "N";
		else if ( this.state.selectedPackaging == "Polybag" )
			option.strPolyBagFilter	= "Y";

		option.nPartsCntLower	= this.getPartsCountInfo( this.state.selectedPartCount ).l;
		option.nPartsCntUpper	= this.getPartsCountInfo( this.state.selectedPartCount ).u;

		blapp.models.fetch(
			"browseInfo"
		,	{
				controller:	"catalog.BLCCatalogBrowse"
			,	method:		"getByOption"
			,	params:		[ option ]
			,	refresh:	true
			}
		).then(
			( data ) =>
			{
				let bCategoryChanged	= ( this.browseInfo.dmBaseCategory.strCatStr != data.dmBaseCategory.strCatStr );

				this.browseInfo	= data;
				this.buildFromBrowseInfo();

				let newState 	= _.assign( { dummy: this.state.dummy + 1 }, this.getNewStateFromBrowseInfo() );
				let strQS		= this.browseInfo.strQS;
				
				this.setState( newState );

				if ( !bCategoryChanged && newState.subCategoryOpen != "" )
					strQS += ( strQS == "" ? "" : "&" ) + "so=" + newState.subCategoryOpen;

				if ( bCategoryChanged )
					window.history.pushState( null, document.title, blapp.url2.getGeneralUrl( this.browseInfo.strPath + ( strQS ? ( "?" + strQS ) : "" ) ) );
				else
					window.history.replaceState( null, document.title, blapp.url2.getGeneralUrl( this.browseInfo.strPath + ( strQS ? ( "?" + strQS ) : "" ) ) );
			}
		).catch(
			( err ) =>
			{
				console.log( err );
			}
		);
	}

	getSortOrderInfo( idx )
	{
		switch ( idx )
		{
		case 1:		return "Item number";
		case 2:		return "Item name";
		case 3:		return "Date added";
		case 4:		return "Date updated";
		case 5:		return "Known colors";
		case 6:		return "Appears In";
		case 7:		return "Parts count";
		case 8:		return "Minifigures count";
		case 9:		return "Available lots";
		default:	return "Default";
		}
	}

	getPartsCountInfo( idx )
	{
		switch ( parseInt( idx ) )
		{
		case 1:		return { l: 0,		u: 10,		t: "10 or less" };
		case 2:		return { l: 11,		u: 50,		t: "11-50" };
		case 3:		return { l: 51,		u: 100,		t: "51-100" };
		case 4:		return { l: 101,	u: 300,		t: "101-300" };
		case 5:		return { l: 301,	u: 500,		t: "401-500" };
		case 6:		return { l: 501,	u: 1000,	t: "501-1000" };
		case 7:		return { l: 1001,	u: 0,		t: "More than 1,000" };
		default:	return { l: 0,		u: 0,		t: "Any" };
		}
	}

	gotoMinifigSeries( strCatStr )
	{
		if ( strCatStr != "" )
		{
			window.location.href	= blapp.url2.getCatalogBrowseUrl( strCatStr );
		}
	}

	doShowAll()
	{
		this.setState( { showAll: true, fetchSerial: this.state.fetchSerial + 1 } );
	}

	onInputKeyUp( e )
	{
		if ( e.keyCode == 13 )
		{
			this.setState({fetchSerial: this.state.fetchSerial + 1});
		}
	}

	onSearchInputKeyUp( e )
	{
		if ( e.keyCode == 13 )
		{
			this.doShowAll();
		}

	}

	submitSearch() {
		this.doShowAll();
	}



	onPageChange( p )
	{
		this.setState( { currentPage: p, fetchSerial: this.state.fetchSerial + 1 } );
		this.initStickySidebar();
	}

	onPopState( e )
	{
		blapp.models.fetch(
			"browseInfo"
		,	{
				controller:	"catalog.BLCCatalogBrowse"
			,	method:		"getByPath"
			,	params:		[ window.location.href ]
			,	refresh:	true
			}
		).then(
			( data ) =>
			{
				this.browseInfo	= data;
				this.buildFromBrowseInfo();

				this.setState( _.assign( { dummy: this.state.dummy + 1 }, this.getNewStateFromBrowseInfo() ) );
			}
		).catch(
			( err ) =>
			{
				console.log( err );
			}
		);		
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<CatalogBrowse blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-catalog-browse' )
						);
		blapp.refs.register( "main", elem );
	}
);

var $T = BLComponent.createTextMap( 
		{
			"":
			{
				"en":	""
			,	"kr":	""
			,	"es":	""
			}
		}
);
 

